import { ANSWER } from 'site-modules/shared/constants/smiley-survey';

export const PRICE_CHECKER_SMILEY_SURVEY_CONFIG = {
  questionClassName: 'px-3',
  question: 'How easy was it to determine if you got a good price from the dealer?',
  creativeId: 'price_checker_survey',
  smileyTrackingId: 'pc_completed_survey',
  textTrackingIdMap: {
    [ANSWER.DISSATISFIED]: 'pc_survey_dissat_comments',
    [ANSWER.NEUTRAL]: 'pc_survey_neutral_comments',
    [ANSWER.SATISFIED]: 'pc_survey_sat_comments',
  },
};
